import React from 'react';
import { solutions } from '../../data/content';
import { CtaButton } from './CtaButton';
import { SolutionCard } from './SolutionCard';
export function Solutions() {
  return <section id="solutions" className="overflow-hidden bg-sand py-20 sm:py-28" data-id="element-210" data-mp="9y0sgkh56gok">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-211" data-mp="a03gx02nc1r6">
        <div className="mx-auto max-w-3xl text-center" data-id="element-212" data-mp="4zz7tv42i9az">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-gold" data-id="element-213" data-mp="12moguox6tm6c">Transform a room in just one day</p>
          <h2 className="mt-4 font-serif text-4xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-214" data-mp="xn1spkftmlir">
            Real problems. <em className="text-gold" data-id="element-215" data-mp="sw38wavmj5ar">Practical</em> solutions.
          </h2>
        </div>
      </div>

      <div className="marquee-pause mt-12 overflow-x-auto [scrollbar-width:none] motion-safe:overflow-x-hidden [&::-webkit-scrollbar]:hidden" data-id="element-216" data-mp="nyjtv8r3qohr">
        <div className="animate-marquee-cards flex w-max items-stretch gap-5 px-6" data-id="element-217" data-mp="1lf8uiz4bfkpk">
          {solutions.map(s => <SolutionCard key={s.title} {...s} data-id="element-218" data-mp="2kwvhe79w3otl" />)}
          {solutions.map(s => <SolutionCard key={`${s.title}-copy`} {...s} hidden data-id="element-219" data-mp="2pvynzw5iq33o" />)}
        </div>
      </div>

      <div className="mx-auto mt-14 max-w-7xl px-6 lg:px-10" data-id="element-220" data-mp="2b726z9lhhfqx">
        <div className="flex flex-col gap-7 bg-ink p-8 text-cream sm:p-10 lg:flex-row lg:items-center lg:justify-between" data-id="element-221" data-mp="2b6sffhksj0j4">
          <div data-id="element-222" data-mp="2g3sn1wxagbcc">
            <p className="font-serif text-2xl font-bold leading-snug sm:text-3xl" data-id="element-223" data-mp="226m4o3gh8enn">
              Start with that one corner you've been wanting to change
            </p>
            <p className="mt-3 text-cream/75" data-id="element-224" data-mp="265v0ddv2umlu">Without automatically turning it into a major renovation project.</p>
          </div>
          <CtaButton variant="gold" className="w-full shrink-0 sm:w-auto" data-id="element-225" data-mp="1x714jppkm09c">Get all 101 solutions</CtaButton>
        </div>
      </div>
    </section>;
}